import * as React from "react"

interface IOrthodonticReferralProvningskonsultPrompt {
    selectedDecision: string | undefined;
    motivation: string | undefined;
}


export const OrthodonticReferralProvningskonsultPrompt: React.FunctionComponent<IOrthodonticReferralProvningskonsultPrompt> = ({ selectedDecision, motivation }) => {

    return (
        <>
            <p>{`Du fattar nu beslut om "${selectedDecision ?? ""}" med motivering:`}</p>
            <p>{`"${motivation ?? ""}"`}</p>
            <p>Vill du skicka beslutet och avsluta hanteringen av denna remiss?</p>
        </>
    );
}